
export default {
  methods: {
    formatCPFCNPJ (val = '') {
      return val === null ? '' : val.length <= 11 ? val.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : val.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    },
    formatCEP (val = '') {
      return val === null ? '' : val.replace(/(\d{5})(\d{3})/, '$1-$2')
    },
    formatPhoneNumber (phone = '') {
      return phone === null ? '' : phone.length === 9 ? phone.replace(/(\d{5})(\d{4})/, '$1-$2') : phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    },
    formatStatus (val = '') {
      return val ? 'Ativo' : 'Inativo'
    },
    formatReplaceCpfCnpj (cpfCnpj) {
      cpfCnpj = cpfCnpj.replace('.', '')
      cpfCnpj = cpfCnpj.replace('.', '')
      cpfCnpj = cpfCnpj.replace('-', '')
      cpfCnpj = cpfCnpj.replace('/', '')
      return cpfCnpj
    },
    formatReplaceCep (cep) {
      cep = cep.replace('-', '')
      return cep
    },
    formatReplacePhone (phone) {
      phone = phone.replace('(', '')
      phone = phone.replace(')', '')
      phone = phone.replace('-', '')
      phone = phone.replace(' ', '')
      return phone
    }
  }
}
